const entriesToObjArray = ([key, value]: [string, unknown]): {
  key: string;
  value: unknown;
} => ({ key, value });

const entriesToSingleFieldObjArray = ([key, value]: [string, unknown]): {
  [field: string]: unknown;
} => ({ [key]: value });

export { entriesToObjArray, entriesToSingleFieldObjArray };
